<script lang="ts">
  import { onDestroy, onMount } from "svelte";
  import { initializePopManager, cleanupPopManager } from "./popManager";
  import { currentEnvironment } from "$lib/utils/previewMode";

  onMount(() => {
    initializePopManager(currentEnvironment());
  });

  onDestroy(() => {
    cleanupPopManager();
  });
</script>
